import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  thinkingText: {
    defaultValue: 'Pensando...',
    key: 'NicheDescription-thinkingText',
  },
})
